import React, { Component } from 'react';
import isContractInitialized from '../../utils/ContractInitializationState';
import LoadingAnimation from '../Components/LoadingAnimation';
import {
  addTransactionInProgress,
  transactionErrorHandler,
  transactionReceiptHandler
} from '../../utils/TransactionStateHelper';
import { TX_SET_NAME } from '../../utils/TransactionTypes';

export default class SetName extends Component {
  constructor (props) {
    super(props);

    this.state = {
      name: '',
      contractLoaded: false
    };

    this.storageUnsubscribe = null;
  }

  componentDidMount () {
    this.isContractLoaded();
    this.storageUnsubscribe = Storage.subscribe(() => this.isContractLoaded());
  }

  isContractLoaded () {
    isContractInitialized() && !this.state.contractLoaded && this.init();
  }

  componentWillUnmount () {
    this.storageUnsubscribe && this.storageUnsubscribe();
  }

  init () {
    this.setState({
      contractLoaded: true,
      name: this.fetchName()
    });
  }

  fetchName () {
    return window.addressToNameService.getNameForAddress(Storage.getState().account.currentAccount) || '';
  }

  handleNameChange = (event) => {
    this.setState({
      name: event.target.value
    });
  };

  handleNameChangeSubmit = (event) => {
    // We don't want normal page submit
    event.preventDefault();

    window.contract
      .methods
      .setName(this.state.name)
      .send({from: Storage.getState().account.currentAccount, gasPrice: 0})
      .on('transactionHash', hash => addTransactionInProgress(hash, TX_SET_NAME))
      .on('receipt', (receipt) => transactionReceiptHandler(receipt, () => {
        window.addressToNameService.setNameForAddress(
          Storage.getState().account.currentAccount,
          this.state.name
        );
      }))
      .on('error', (err, receipt) => transactionErrorHandler(err, receipt));
  };

  renderForm () {
    if (!this.state.contractLoaded) {
      return (<LoadingAnimation/>);
    }

    return (
      <form onSubmit={this.handleNameChangeSubmit}>
        <div className="c-form-row">
          <label>Name</label>
          <input type="text" placeholder="Name" name="name" value={this.state.name} onChange={this.handleNameChange}/>
        </div>
        <div className="c-form-row">
          <input type="submit" value="Set name"/>
        </div>
      </form>
    );
  }

  render () {
    return (
      <div className="c-component c-set-name">
        <h2>Set name</h2>
        {this.renderForm()}
      </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/SettingsPage/SetName.js